import { httpClient } from './http';

export type ClientAppointmentNotesPayload = {
  kind: 'piercing' | 'tattoo';
  noteHtml?: string;
  piercings?: Array<{ bodyZone?: string; piercingType?: string; noteHtml?: string }>;
};

export type ClientAppointmentsResponse = {
  success: boolean;
  data?: { appointments?: any[]; clientNotes?: string | null };
  message?: string;
};

export type PiercingRecordDetail = {
  id: string;
  actId?: string | null;
  piercingType: string;
  placement: { area: string; side?: string; specific?: string };
  jewelry: { type: string; material: string; gauge: string };
  technique: { method: string; tools?: string };
  needleGauge: string;
  healingTime: number;
  aftercareProvided: { products?: string; instructions?: string };
  complications: string[];
  isHealed: boolean;
};

export type ClientAppointmentDetailResponse = {
  success: boolean;
  data?: {
    id: string;
    piercingRecords?: PiercingRecordDetail[];
    [key: string]: any;
  };
  message?: string;
};

export const clientAppointmentsApi = {
  async list(): Promise<ClientAppointmentsResponse> {
    return httpClient.get<ClientAppointmentsResponse>('/api/clients/appointments');
  },
  async getDetail(appointmentId: string): Promise<ClientAppointmentDetailResponse> {
    return httpClient.get<ClientAppointmentDetailResponse>(`/api/clients/appointments/${appointmentId}`);
  },
  async updateNotes(appointmentId: string, payload: ClientAppointmentNotesPayload): Promise<ClientAppointmentsResponse> {
    return httpClient.put<ClientAppointmentsResponse>(`/api/clients/appointments/${appointmentId}/notes`, payload);
  },
};
